import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalService } from "app/services/global.service";

@Component({
  selector: "app-cancel-subscription",
  templateUrl: "./cancel-subscription.component.html",
  styles: [],
})
export class CancelSubscriptionComponent implements OnInit {
  @Input() content: any;
  loader = false;
  appname = "Cruzo";
  constructor(public dialogRef: NgbActiveModal, public global: GlobalService) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close({ success: false });
  }
  onSubmit() {
    this.dialogRef.close({ success: true });
  }
}
